import { FC } from 'react';
import ReactLoadingOverlay from 'react-loading-overlay';
import Spinner from '../spinner';

interface Props {
  active: Boolean;
  spinner?: React.ReactNode;
}

const LoadingOverlay: FC<Props> = ({
  children,
  active,
  spinner = <Spinner />,
}) => {
  return (
    <ReactLoadingOverlay
      active={active}
      spinner={spinner}
      styles={{
        overlay: base => ({
          ...base,
          background: 'rgba(232, 237, 238, 0.7)',
        }),
      }}
    >
      {children}
    </ReactLoadingOverlay>
  );
};

export default LoadingOverlay;
